import { formatDateToString } from "../../utils/formatDateToString";

type HighlightedDateProps = {
    style: "warning" | "alert" | "none";
    date: string;
    showTrailingComma: boolean;
};

const getStyleClass = (style: HighlightedDateProps["style"]) => {
    switch (style) {
        case "warning":
            return "bg-S2D-warning-90";
        case "alert":
            return "bg-S2D-error-40 text-white";
        case "none":
        default:
            return "";
    }
};

export const HighlightedDate = ({
    style,
    date,
    showTrailingComma,
}: HighlightedDateProps) => {
    const formattedDate = formatDateToString(new Date(date));
    return (
        <>
            <span className={`rounded-sm p-1 ${getStyleClass(style)}`}>
                {formattedDate}
            </span>
            {showTrailingComma ? ", " : ""}
        </>
    );
};

export default HighlightedDate;
